import { jsx as _jsx } from "react/jsx-runtime";
import { Download, Fields, Link, Move } from "@air/next-icons";
import { useCallback } from "react";
/**
 * Use this utility to build out the order of the options you'd see in an ellipsis menu for a board. Just pass the functions you want, with the board (and it's permissions).
 */ export const useGetPublicBoardMenuOptions = ()=>{
    const getBoardMenuOptions = useCallback((param)=>{
        let { onShare, onDownload, onCopyToAir, customFieldsMenuOptions } = param;
        const options = [];
        onShare && options.push({
            id: "share",
            label: "Share a link",
            onSelect: onShare,
            prefix: /*#__PURE__*/ _jsx(Link, {
                className: "size-4"
            }),
            type: "item"
        });
        onDownload && options.push({
            id: "download",
            label: "Download",
            prefix: /*#__PURE__*/ _jsx(Download, {
                className: "size-4"
            }),
            onSelect: onDownload,
            type: "item"
        });
        customFieldsMenuOptions && customFieldsMenuOptions.length > 0 && options.push({
            id: "edit-custom-fields",
            prefix: /*#__PURE__*/ _jsx(Fields, {
                className: "size-4"
            }),
            label: "Edit custom fields",
            options: customFieldsMenuOptions,
            type: "sub"
        });
        onCopyToAir && options.push({
            id: "copy-to-air",
            prefix: /*#__PURE__*/ _jsx(Move, {
                className: "size-4"
            }),
            label: "Copy to Air workspace",
            onSelect: onCopyToAir,
            type: "item"
        });
        return options;
    }, []);
    return {
        getBoardMenuOptions
    };
};
